import { useEffect, useState } from "react";
import {
  subscribeActiveEditorJob,
  subscribeEditorMessages,
} from "@/lib/firestore/editorServices";
import type { EditorMessage, EditorServiceJob } from "@/types";

export function useEditorService(projectId: string | null) {
  const [job, setJob] = useState<EditorServiceJob | null>(null);
  const [messages, setMessages] = useState<EditorMessage[]>([]);
  const [loading, setLoading] = useState(true);
  const [messagesLoading, setMessagesLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [messagesError, setMessagesError] = useState<string | null>(null);

  useEffect(() => {
    if (!projectId) {
      setJob(null);
      setMessages([]);
      setLoading(false);
      setMessagesLoading(false);
      setError(null);
      setMessagesError(null);
      return;
    }

    setLoading(true);
    setMessagesLoading(true);

    const unsubscribeJob = subscribeActiveEditorJob(
      projectId,
      (nextJob) => {
        setJob(nextJob);
        setLoading(false);
        setError(null);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      },
    );

    const unsubscribeMessages = subscribeEditorMessages(
      projectId,
      (nextMessages) => {
        setMessages(nextMessages);
        setMessagesLoading(false);
        setMessagesError(null);
      },
      (err) => {
        setMessagesError(err.message);
        setMessagesLoading(false);
      },
    );

    return () => {
      unsubscribeJob();
      unsubscribeMessages();
    };
  }, [projectId]);

  return {
    job,
    messages,
    loading,
    messagesLoading,
    error,
    messagesError,
  };
}
